import clientConfig from '../client/config';

const { analyticsCookieName } = clientConfig;

const hasAnalyticsCookie = () => document.cookie.includes(analyticsCookieName);

export default hasAnalyticsCookie;
